/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface CompanySettings
 */
export interface CompanySettings {
  /**
   *
   * @type {boolean}
   * @memberof CompanySettings
   */
  unregisteredSmsDisabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanySettings
   */
  messagingDisabled?: boolean;
}

/**
 * Check if a given object implements the CompanySettings interface.
 */
export function instanceOfCompanySettings(
  value: object,
): value is CompanySettings {
  return true;
}

export function CompanySettingsFromJSON(json: any): CompanySettings {
  return CompanySettingsFromJSONTyped(json, false);
}

export function CompanySettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanySettings {
  if (json == null) {
    return json;
  }
  return {
    unregisteredSmsDisabled:
      json['unregistered_sms_disabled'] == null
        ? undefined
        : json['unregistered_sms_disabled'],
    messagingDisabled:
      json['messaging_disabled'] == null
        ? undefined
        : json['messaging_disabled'],
  };
}

export function CompanySettingsToJSON(value?: CompanySettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    unregistered_sms_disabled: value['unregisteredSmsDisabled'],
    messaging_disabled: value['messagingDisabled'],
  };
}
